import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'base-ui/dist/Button';
import Icon from 'base-ui/dist/Icon';
import { useAmp } from 'next/amp';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const getWpAdminEditUrl = ({ type, id }) => {
  switch (type) {
    case 'post': {
      return `${publicRuntimeConfig.PUBLIC_URL}/wp-admin/post.php?post=${id}&action=edit`;
    }
    case 'page': {
      return `${publicRuntimeConfig.PUBLIC_URL}/wp-admin/post.php?post=${id}&action=edit`;
    }
    case 'category': {
      return `${publicRuntimeConfig.PUBLIC_URL}/wp-admin/term.php?taxonomy=category&tag_ID=${id}`;
    }
    case 'tag': {
      return `${publicRuntimeConfig.PUBLIC_URL}/wp-admin/term.php?taxonomy=post_tag&tag_ID=${id}`;
    }
    case 'user': {
      return `${publicRuntimeConfig.PUBLIC_URL}/wp-admin/user-edit.php?user_id=${id}`;
    }
    default: {
      return '';
    }
  }
};

const WpBar = (props) => {
  const [wpLoggedIn] = useState(props.wpLoggedIn);

  if (!wpLoggedIn || useAmp()) return null;

  return (
    <div id="wp-bar">
      <div className="wrapper">
        <div className="logo">
          <Icon prefix="fab" name="wordpress-simple" color="white" size="medium" />
        </div>

        {props?.currentResource?.id && (
          <Button
            color="white"
            size="small"
            onClick={() => {
              window.location.href = getWpAdminEditUrl(props?.currentResource);
            }}
          >
            Edit
          </Button>
        )}

        <Button
          color="white"
          size="small"
          onClick={() => {
            window.location.href = '/wp-admin';
          }}
        >
          Dashboard
        </Button>
      </div>

      <style jsx>
        {`
          #wp-bar {
            padding: 2px 5px;
            background-color: #191E23;
          }

          #wp-bar .wrapper {
            display: flex;
            align-items: center;
            align-self: center;
            margin: 0 auto;
            padding: 0 2rem;
          }

          #wp-bar .logo {
            flex-grow: 1;
          }

          #wp-bar .btn {
            margin: 0 5px;
          }
      `}
      </style>
    </div>
  );
};

WpBar.propTypes = {
  wpLoggedIn: PropTypes.bool,
  currentResource: PropTypes.object
};

export default WpBar;
